import React from 'react';
import { Slide } from '@mui/material';

const SlideUpTransition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export default SlideUpTransition;
